module.exports = __webpack_public_path__ + "img/t5-6.47b825ec.svg";